<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="systemGroups"
      :items="systemGroups"
      :fields="systemGroupsFields"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedSystemGroups"/>
  </div>
</template>

<script>
import editModal from './editModal'
export default {
  components: {
    editModal
  },
  data () {
    return {
      systemGroupsFields: [
        { key: 'group_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'group_info', label: this.$i18n.t('Info'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      selectedSystemGroups: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedSystemGroups = {
        group_id: 0,
        group_name: '',
        group_info: '',
        web_settings: 'e30=',
        fids: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditSystemGroups', '#btnShow')
    },
    editItem (item) {
      this.selectedSystemGroups = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditSystemGroups', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    systemGroups () {
      return this.$store.getters['Users/SYSTEM_GROUPS']
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_SYSTEM_GROUPS')
    this.$store.dispatch('Settings/GET_ALL_ROUTES')
    this.$store.dispatch('Settings/GET_API_PERMISSIONS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemGroups/main.vue